export const CASH_IN_CALLBACK = "WALLET/cash_in_callback";
